<template>
  <div class="location-details">
    <template v-for="item in locationDetails" :key="item.type">
      <div
        class="section-title"
        v-if="item.type === 'title' && checkFieldConditions(item)"
        v-html="__(item.content)"></div>
      <div
        class="location-details-body-text"
        v-else-if="item.type === 'body-text' && checkFieldConditions(item)"
        v-html="__(item.content)"></div>
      <div
        class="location-details-highlighted-text"
        v-else-if="item.type === 'highlighted-text' && checkFieldConditions(item)"
        v-html="__(item.content)"></div>
      <div
        class="location-details-options-selector"
        v-else-if="item.type === 'options-selector' && checkFieldConditions(item)">
        <template v-for="option in item.options" :key="option.value">
          <input
            type="radio"
            :id="option.value"
            :name="`location-option-${locationId}`"
            class="location-option-input"
            :value="option.value"
            v-model="selectedLocation" />
          <label :for="option.value" class="location-option-label" v-html="option.content"></label>
        </template>
      </div>
      <div
        class="location-details-subtitle"
        v-if="item.type === 'subtitle' && checkFieldConditions(item)"
        v-html="__(item.content)"></div>

      <div class="locations-details-image" v-if="item.type === 'image' && checkFieldConditions(item)">
        <img :src="item.content" class="locations-details-image-main" />

        <div class="locations-details-image-row" v-if="item.link || item.info">
          <div class="locations-details-image-row-box" v-if="item.info">
            <img src="@/assets/icons/infoIcon.svg" />
            <p class="link-text">More info</p>
          </div>
          <a
            :href="item.link"
            rel="noopener noreferrer"
            target="_blank"
            class="locations-details-image-row-box"
            v-if="item.link">
            <p class="link-text">{{ __('location_action') }}</p>
            <div class="arrow right-arrow"></div>
          </a>
        </div>
      </div>

      <div class="locations-details-directions" v-else-if="item.type === 'directions' && checkFieldConditions(item)">
        <div class="locations-details-directions-options">
          <p class="locations-details-directions-options-title" v-html="item.title"></p>
          <div class="locations-details-directions-options-option" v-for="option in item.options" :key="option.value">
            <img :src="'/locations/directions/direction_' + option.value + '.svg'" alt="" />
            <p class="locations-details-directions-options-option-direction" v-html="option.content"></p>
          </div>
        </div>
        <img class="locations-details-directions-image" :src="item.image" v-if="item.image" />
      </div>

      <div class="locations-details-accordion" v-if="item.type === 'accordion' && checkFieldConditions(item)">
        <div class="accordion-item" v-for="option in item.options" :key="option.value">
          <div class="accordion-item-header">
            <p class="accordion-item-title" v-html="option.title"></p>
            <div
              class="arrow"
              :class="{
                'up-arrow': accrodionOpened.includes(option.value),
                'down-arrow': !accrodionOpened.includes(option.value),
              }"
              @click="toggleAccordion(option.value)"></div>
          </div>
          <div
            class="accordion-item-content"
            v-html="option.content"
            v-if="accrodionOpened.includes(option.value)"></div>
        </div>
      </div>
      <div class="location-details-bus-stops" v-else-if="item.type === 'bus-stops' && checkFieldConditions(item)">
        <div class="location-details-bus-stops-body">
          <div class="location-details-bus-stops-title location-details-subtitle" v-html="__(item.title)"></div>
          <p class="location-details-bus-stops-sub-title" v-html="__('location_details_bus_lines')"></p>
          <div class="location-details-bus-stops-numbers">
            <div
              class="location-details-bus-stops-number"
              v-for="option in item.options"
              :style="{ background: option.color }"
              :key="option.value"
              v-html="option.content"></div>
          </div>
        </div>

        <img :src="item.image" class="location-details-bus-stops-image" v-if="item.image" />
      </div>
      <div class="locations-details-map" v-else-if="item.type === 'map' && checkFieldConditions(item)">
        <LocationDetailsMap
          :center="item.center"
          :marker-positions="item.markerPositions"
          :bus-stops="item.busStops"
          :zoom="item.zoom" />
        <a
          :href="item.link"
          rel="noopener noreferrer"
          target="_blank"
          class="locations-details-map-box"
          v-if="item.link">
          <p class="link-text">{{ __('location_action') }}</p>
          <div class="arrow right-arrow"></div>
        </a>
      </div>
      <div class="locations-details-parking" v-else-if="item.type === 'parking' && checkFieldConditions(item)">
        <p class="locations-details-parking-title" v-html="__(item.title)" v-if="item.title"></p>
        <div class="locations-details-parking-box">
          <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="82" height="82" rx="2" fill="#276EFC" />
            <path
              d="M20.0166 63.3899V18.6091H41.5754C45.7549 18.6091 49.3587 19.2915 52.3867 20.6563C55.4574 22.021 57.8244 23.9828 59.4877 26.5417C61.151 29.058 61.9826 32.0434 61.9826 35.4979C61.9826 38.9524 61.151 41.9378 59.4877 44.4541C57.8244 46.9703 55.4574 48.9321 52.3867 50.3395C49.3587 51.7043 45.7549 52.3867 41.5754 52.3867H28.397L35.1141 45.9254V63.3899H20.0166ZM35.1141 47.5887L28.397 40.7436H40.6158C42.7055 40.7436 44.2409 40.2745 45.2218 39.3362C46.2454 38.398 46.7571 37.1185 46.7571 35.4979C46.7571 33.8773 46.2454 32.5978 45.2218 31.6595C44.2409 30.7213 42.7055 30.2521 40.6158 30.2521H28.397L35.1141 23.4071V47.5887Z"
              fill="white" />
          </svg>

          <div class="locations-details-parking-box-column">
            <div class="locations-details-parking-box-column-text">
              {{ __('location_details_parking_available_spaces') }}
            </div>
            <div
              class="locations-details-parking-box-column-value"
              :class="{
                'locations-details-parking-box-column-value-low':
                  parseInt(parkingData[item.api]?.value?.empty || '0') > 0 &&
                  parseInt(parkingData[item.api]?.value?.empty || '0') <= 3,
                'locations-details-parking-box-column-value-zero':
                  parseInt(parkingData[item.api]?.value?.empty || '0') === 0,
              }"
              v-html="parkingData[item.api]?.value?.empty || 0"></div>
            <div class="locations-details-parking-box-column-last-checked">
              {{ __('location_details_parking_last_checked') }}:
              {{ QDateTime.parse(parkingData[item.api]?.createdAt).format('dd.MM.yyyy, HH:mm') }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="locations-details-image-directions"
        v-else-if="item.type === 'image-directions' && checkFieldConditions(item)">
        <p class="locations-details-image-directions-title" v-html="__(item.title)" v-if="item.title"></p>
        <img :src="item.image" class="locations-details-image-directions-image" />
      </div>
      <div class="locations-details-breaker" v-if="item.type === 'breaker' && checkFieldConditions(item)"></div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import router from '@/router';
import { generalStore } from '@/store';
import __ from '@/translate';
import { LocationDetails } from '@/types';
import { onMounted, ref } from 'vue';
import LocationDetailsMap from '@/components/LocationDetailsMap.vue';
import axios from 'axios';
import QDateTime from '@/QDateTime';

const store = generalStore();
const locationId = ref(router.currentRoute.value.params.id.toString());
const selectedLocation = ref('');
const accrodionOpened = ref<string[]>([]);
const parkingData = ref<
  Record<
    string,
    {
      key: string;
      value: {
        available: string;
        empty: string;
        status: string;
      };
      createdAt: string;
    }
  >
>({});

const locationDetailsAll: Record<string, LocationDetails[]> = {
  'Ljubljana - RTG': [
    // CAR
    {
      type: 'title',
      content: 'location_details_ljubljana_title',
    },
    {
      type: 'options-selector',
      options: [
        {
          value: 'car',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none"><path d="M32.4447 6.31295C32.3686 6.09151 32.099 5.91928 31.8739 5.91928C30.8992 5.91928 29.9247 5.91928 28.9499 5.91928C28.7249 5.91928 28.4552 6.09151 28.3791 6.31295C28.3047 6.52969 28.249 6.72308 28.2121 6.90496L26.2589 1.50136C25.9367 0.61031 25.0835 0.0116577 24.1361 0.0116577H9.19757C8.25009 0.0116577 7.39707 0.61031 7.07476 1.50152L5.1215 6.9056C5.08444 6.72357 5.02882 6.52994 4.9543 6.31295C4.87824 6.09151 4.60855 5.91928 4.38354 5.91928C3.4089 5.91928 2.43425 5.91928 1.45953 5.91928C1.23452 5.91928 0.964827 6.09151 0.88877 6.31295C0.592646 7.17513 0.592808 7.6687 0.888851 8.53096C0.964909 8.7524 1.2346 8.92463 1.45961 8.92463C2.43433 8.92463 3.40898 8.92463 4.38362 8.92463C4.38638 8.92463 4.3893 8.9239 4.39214 8.92382L4.34803 9.04601C3.75181 9.2441 3.32133 9.80537 3.32133 10.4682V14.9931V15.366V20.3732C3.32133 20.7713 3.64388 21.0938 4.04193 21.0938H7.66863C8.0666 21.0938 8.38923 20.7713 8.38923 20.3732V16.8653H24.9444V20.3732C24.9444 20.7713 25.267 21.0938 25.665 21.0938H29.2917C29.6898 21.0938 30.0123 20.7713 30.0123 20.3732V15.366V14.9931V10.4682C30.0123 9.80554 29.582 9.24434 28.986 9.04609L28.9418 8.92382C28.9445 8.9239 28.9473 8.92455 28.95 8.92455C29.9247 8.92455 30.8993 8.92455 31.874 8.92455C32.0991 8.92455 32.3687 8.75232 32.4448 8.53088C32.7408 7.6687 32.7407 7.17513 32.4447 6.31295ZM9.47351 2.66347H23.8582L26.1373 8.96882H7.19444L9.47351 2.66347ZM9.87471 13.4107H6.84067C6.18972 13.4107 5.66209 12.8831 5.66209 12.2322C5.66209 11.5813 6.18963 11.0536 6.84067 11.0536H9.87471C10.5256 11.0536 11.0533 11.5812 11.0533 12.2322C11.0534 12.8831 10.5256 13.4107 9.87471 13.4107ZM26.4927 13.4107H23.4587C22.8078 13.4107 22.2801 12.8831 22.2801 12.2322C22.2801 11.5813 22.8078 11.0536 23.4587 11.0536H26.4927C27.1437 11.0536 27.6713 11.5812 27.6713 12.2322C27.6713 12.8831 27.1437 13.4107 26.4927 13.4107Z" fill="#6C6D70"/></svg>',
        },
        {
          value: 'bus',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M3.3333 15.2194V11.2194C3.7013 11.2194 3.99998 10.9208 3.99998 10.5528C3.99998 10.1848 3.7013 9.88608 3.3333 9.88608C1.49468 9.88608 0 11.3821 0 13.2194V14.5527C0 15.6554 0.897309 16.5527 1.99999 16.5527H3.3333C3.7013 16.5527 3.99998 16.2541 3.99998 15.8861C3.99998 15.5181 3.7013 15.2194 3.3333 15.2194Z" fill="#6C6D70"/><path d="M28.6667 9.88608C28.2987 9.88608 28 10.1848 28 10.5528C28 10.9208 28.2987 11.2194 28.6667 11.2194V15.2194C28.2987 15.2194 28 15.5181 28 15.8861C28 16.2541 28.2987 16.5527 28.6667 16.5527H30C31.1027 16.5527 32 15.6554 32 14.5527V13.2194C32 11.3821 30.5053 9.88608 28.6667 9.88608Z" fill="#6C6D70"/><path d="M11.3333 28.5527C10.9653 28.5527 10.6666 28.8514 10.6666 29.2194H6.66662C6.66662 28.8514 6.36794 28.5527 5.99994 28.5527C5.63194 28.5527 5.33325 28.8514 5.33325 29.2194V30.5527C5.33325 31.6554 6.23056 32.5527 7.33324 32.5527H9.99998C11.1027 32.5527 12 31.6554 12 30.5527V29.2194C12 28.8514 11.7013 28.5527 11.3333 28.5527Z" fill="#6C6D70"/><path d="M26 28.5527C25.632 28.5527 25.3333 28.8514 25.3333 29.2194H21.3333C21.3333 28.8514 21.0346 28.5527 20.6666 28.5527C20.2986 28.5527 20 28.8514 20 29.2194V30.5527C20 31.6554 20.8973 32.5527 22 32.5527H24.6667C25.7694 32.5527 26.6667 31.6554 26.6667 30.5527V29.2194C26.6667 28.8514 26.368 28.5527 26 28.5527Z" fill="#6C6D70"/><path d="M26 0.552734H6.00005C4.16137 0.552734 2.66675 2.04873 2.66675 3.88603V26.5526C2.66675 28.3899 4.16143 29.8859 6.00005 29.8859H26C27.8386 29.8859 29.3333 28.3899 29.3333 26.5526V3.88603C29.3333 2.04873 27.8386 0.552734 26 0.552734ZM8.66672 3.21941H23.3334C24.436 3.21941 25.3333 4.11672 25.3333 5.2194C25.3333 6.32209 24.436 7.21939 23.3334 7.21939H8.66672C7.56404 7.21939 6.66673 6.32209 6.66673 5.2194C6.66673 4.11672 7.56404 3.21941 8.66672 3.21941ZM8.66672 25.8859C7.56404 25.8859 6.66673 24.9886 6.66673 23.886C6.66673 22.7833 7.56404 21.886 8.66672 21.886C9.76941 21.886 10.6667 22.7833 10.6667 23.886C10.6667 24.9886 9.76934 25.8859 8.66672 25.8859ZM23.3333 25.8859C22.2306 25.8859 21.3333 24.9886 21.3333 23.886C21.3333 22.7833 22.2306 21.886 23.3333 21.886C24.436 21.886 25.3333 22.7833 25.3333 23.886C25.3333 24.9886 24.436 25.8859 23.3333 25.8859ZM26.6666 17.2194C26.6666 18.322 25.7693 19.2193 24.6667 19.2193H7.33335C6.23067 19.2193 5.33336 18.322 5.33336 17.2194V10.5527C5.33336 9.45001 6.23067 8.5527 7.33335 8.5527H24.6666C25.7693 8.5527 26.6666 9.45001 26.6666 10.5527V17.2194H26.6666Z" fill="#6C6D70"/></svg>',
        },
      ],
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_intro_car_free_parking_title',
      condition: 'car',
    },
    {
      type: 'map',
      condition: 'car',
      center: { lat: 46.066992, lng: 14.489193 },
      markerPositions: [{ lat: 46.066992, lng: 14.489193 }],
      link: 'https://maps.app.goo.gl/bh49i9YvPNwFWHTB9',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/private-parking-location.jpg',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_title',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/ljubljana/parking-entrance-1.jpg',
      title: 'location_details_ljubljana_intro_car_how_to_enter_parking_1',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/ljubljana/parking-entrance-2.jpg',
      title: 'location_details_ljubljana_intro_car_how_to_enter_parking_2',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/from-private-parking-to-office.jpg',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_end',
      condition: 'car',
    },
    {
      type: 'breaker',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_alternatives_parking_title',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_alternatives_parking_explanation',
      condition: 'car',
    },
    {
      type: 'parking',
      title: 'location_details_ljubljana_alternatives_parking_kino_siska_title',
      api: '/api/parking/trg-prekomorskih-brigad',
      condition: 'car',
    },
    {
      type: 'highlighted-text',
      content: 'location_details_ljubljana_alternatives_parking_kino_siska_title',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_alternatives_parking_kino_siska_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/kino-siska-parking.jpg',
      condition: 'car',
      link: 'https://maps.app.goo.gl/1PtJUReZcFPmhZnA8',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/form-kino-siska-parking-to-office.jpg',
      condition: 'car',
    },

    // BUS

    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_bus',
      condition: 'bus',
    },
    {
      type: 'map',
      condition: 'bus',
      zoom: 16,
      center: { lat: 46.06809029173705, lng: 14.490389151227626 },
      markerPositions: [{ lat: 46.066859341449714, lng: 14.48984228127852 }],
      busStops: [
        { lat: 46.066642356174576, lng: 14.489729089468733 },
        { lat: 46.069667676118804, lng: 14.489616037085472 },
      ],
    },
    {
      condition: 'bus',
      type: 'bus-stops',
      title: 'location_details_ljubljana_bus_stops_najami',
      image: '/locations/ljubljana/bus-stop-na-jami.jpg',
      options: [
        {
          value: 'stop-1',
          content: '7',
          color: '#24A8C3',
        },
      ],
    },
    {
      condition: 'bus',
      type: 'bus-stops',
      image: '/locations/ljubljana/bus-stop-kino-siska.jpg',
      title: 'location_details_ljubljana_bus_stops_kino_siska',
      options: [
        {
          value: 'stop-1',
          content: '1',
          color: '#AD2F31',
        },
        {
          value: 'stop-2',
          content: '1B',
          color: '#AD2F31',
        },
        {
          value: 'stop-3',
          content: '3',
          color: '#D74A35',
        },
        {
          value: 'stop-4',
          content: '3B',
          color: '#D74A35',
        },
        {
          value: 'stop-5',
          content: '5',
          color: '#874481',
        },
        {
          value: 'stop-6',
          content: '8',
          color: '#1B558F',
        },
        {
          value: 'stop-7',
          content: '22',
          color: '#E7963A',
        },
        {
          value: 'stop-8',
          content: '25',
          color: '#007FAD',
        },
        {
          value: 'stop-9',
          content: 'N1',
          color: '#0066AF',
        },
        {
          value: 'stop-10',
          content: 'N3',
          color: '#0066AF',
        },
        {
          value: 'stop-11',
          content: 'N6',
          color: '#0066AF',
        },
      ],
    },
  ],
  Ljubljana: [
    // CAR
    {
      type: 'title',
      content: 'location_details_ljubljana_title',
    },
    {
      type: 'options-selector',
      options: [
        {
          value: 'car',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none"><path d="M32.4447 6.31295C32.3686 6.09151 32.099 5.91928 31.8739 5.91928C30.8992 5.91928 29.9247 5.91928 28.9499 5.91928C28.7249 5.91928 28.4552 6.09151 28.3791 6.31295C28.3047 6.52969 28.249 6.72308 28.2121 6.90496L26.2589 1.50136C25.9367 0.61031 25.0835 0.0116577 24.1361 0.0116577H9.19757C8.25009 0.0116577 7.39707 0.61031 7.07476 1.50152L5.1215 6.9056C5.08444 6.72357 5.02882 6.52994 4.9543 6.31295C4.87824 6.09151 4.60855 5.91928 4.38354 5.91928C3.4089 5.91928 2.43425 5.91928 1.45953 5.91928C1.23452 5.91928 0.964827 6.09151 0.88877 6.31295C0.592646 7.17513 0.592808 7.6687 0.888851 8.53096C0.964909 8.7524 1.2346 8.92463 1.45961 8.92463C2.43433 8.92463 3.40898 8.92463 4.38362 8.92463C4.38638 8.92463 4.3893 8.9239 4.39214 8.92382L4.34803 9.04601C3.75181 9.2441 3.32133 9.80537 3.32133 10.4682V14.9931V15.366V20.3732C3.32133 20.7713 3.64388 21.0938 4.04193 21.0938H7.66863C8.0666 21.0938 8.38923 20.7713 8.38923 20.3732V16.8653H24.9444V20.3732C24.9444 20.7713 25.267 21.0938 25.665 21.0938H29.2917C29.6898 21.0938 30.0123 20.7713 30.0123 20.3732V15.366V14.9931V10.4682C30.0123 9.80554 29.582 9.24434 28.986 9.04609L28.9418 8.92382C28.9445 8.9239 28.9473 8.92455 28.95 8.92455C29.9247 8.92455 30.8993 8.92455 31.874 8.92455C32.0991 8.92455 32.3687 8.75232 32.4448 8.53088C32.7408 7.6687 32.7407 7.17513 32.4447 6.31295ZM9.47351 2.66347H23.8582L26.1373 8.96882H7.19444L9.47351 2.66347ZM9.87471 13.4107H6.84067C6.18972 13.4107 5.66209 12.8831 5.66209 12.2322C5.66209 11.5813 6.18963 11.0536 6.84067 11.0536H9.87471C10.5256 11.0536 11.0533 11.5812 11.0533 12.2322C11.0534 12.8831 10.5256 13.4107 9.87471 13.4107ZM26.4927 13.4107H23.4587C22.8078 13.4107 22.2801 12.8831 22.2801 12.2322C22.2801 11.5813 22.8078 11.0536 23.4587 11.0536H26.4927C27.1437 11.0536 27.6713 11.5812 27.6713 12.2322C27.6713 12.8831 27.1437 13.4107 26.4927 13.4107Z" fill="#6C6D70"/></svg>',
        },
        {
          value: 'bus',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M3.3333 15.2194V11.2194C3.7013 11.2194 3.99998 10.9208 3.99998 10.5528C3.99998 10.1848 3.7013 9.88608 3.3333 9.88608C1.49468 9.88608 0 11.3821 0 13.2194V14.5527C0 15.6554 0.897309 16.5527 1.99999 16.5527H3.3333C3.7013 16.5527 3.99998 16.2541 3.99998 15.8861C3.99998 15.5181 3.7013 15.2194 3.3333 15.2194Z" fill="#6C6D70"/><path d="M28.6667 9.88608C28.2987 9.88608 28 10.1848 28 10.5528C28 10.9208 28.2987 11.2194 28.6667 11.2194V15.2194C28.2987 15.2194 28 15.5181 28 15.8861C28 16.2541 28.2987 16.5527 28.6667 16.5527H30C31.1027 16.5527 32 15.6554 32 14.5527V13.2194C32 11.3821 30.5053 9.88608 28.6667 9.88608Z" fill="#6C6D70"/><path d="M11.3333 28.5527C10.9653 28.5527 10.6666 28.8514 10.6666 29.2194H6.66662C6.66662 28.8514 6.36794 28.5527 5.99994 28.5527C5.63194 28.5527 5.33325 28.8514 5.33325 29.2194V30.5527C5.33325 31.6554 6.23056 32.5527 7.33324 32.5527H9.99998C11.1027 32.5527 12 31.6554 12 30.5527V29.2194C12 28.8514 11.7013 28.5527 11.3333 28.5527Z" fill="#6C6D70"/><path d="M26 28.5527C25.632 28.5527 25.3333 28.8514 25.3333 29.2194H21.3333C21.3333 28.8514 21.0346 28.5527 20.6666 28.5527C20.2986 28.5527 20 28.8514 20 29.2194V30.5527C20 31.6554 20.8973 32.5527 22 32.5527H24.6667C25.7694 32.5527 26.6667 31.6554 26.6667 30.5527V29.2194C26.6667 28.8514 26.368 28.5527 26 28.5527Z" fill="#6C6D70"/><path d="M26 0.552734H6.00005C4.16137 0.552734 2.66675 2.04873 2.66675 3.88603V26.5526C2.66675 28.3899 4.16143 29.8859 6.00005 29.8859H26C27.8386 29.8859 29.3333 28.3899 29.3333 26.5526V3.88603C29.3333 2.04873 27.8386 0.552734 26 0.552734ZM8.66672 3.21941H23.3334C24.436 3.21941 25.3333 4.11672 25.3333 5.2194C25.3333 6.32209 24.436 7.21939 23.3334 7.21939H8.66672C7.56404 7.21939 6.66673 6.32209 6.66673 5.2194C6.66673 4.11672 7.56404 3.21941 8.66672 3.21941ZM8.66672 25.8859C7.56404 25.8859 6.66673 24.9886 6.66673 23.886C6.66673 22.7833 7.56404 21.886 8.66672 21.886C9.76941 21.886 10.6667 22.7833 10.6667 23.886C10.6667 24.9886 9.76934 25.8859 8.66672 25.8859ZM23.3333 25.8859C22.2306 25.8859 21.3333 24.9886 21.3333 23.886C21.3333 22.7833 22.2306 21.886 23.3333 21.886C24.436 21.886 25.3333 22.7833 25.3333 23.886C25.3333 24.9886 24.436 25.8859 23.3333 25.8859ZM26.6666 17.2194C26.6666 18.322 25.7693 19.2193 24.6667 19.2193H7.33335C6.23067 19.2193 5.33336 18.322 5.33336 17.2194V10.5527C5.33336 9.45001 6.23067 8.5527 7.33335 8.5527H24.6666C25.7693 8.5527 26.6666 9.45001 26.6666 10.5527V17.2194H26.6666Z" fill="#6C6D70"/></svg>',
        },
      ],
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_intro_car_free_parking_title',
      condition: 'car',
    },
    {
      type: 'map',
      condition: 'car',
      center: { lat: 46.066992, lng: 14.489193 },
      markerPositions: [{ lat: 46.066992, lng: 14.489193 }],
      link: 'https://maps.app.goo.gl/bh49i9YvPNwFWHTB9',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/private-parking-location.jpg',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_title',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/ljubljana/parking-entrance-1.jpg',
      title: 'location_details_ljubljana_intro_car_how_to_enter_parking_1',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/ljubljana/parking-entrance-2.jpg',
      title: 'location_details_ljubljana_intro_car_how_to_enter_parking_2',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/from-private-parking-to-office.jpg',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_car_how_to_enter_parking_end',
      condition: 'car',
    },
    {
      type: 'breaker',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_ljubljana_alternatives_parking_title',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_alternatives_parking_explanation',
      condition: 'car',
    },
    {
      type: 'parking',
      title: 'location_details_ljubljana_alternatives_parking_kino_siska_title',
      api: '/api/parking/trg-prekomorskih-brigad',
      condition: 'car',
    },
    {
      type: 'highlighted-text',
      content: 'location_details_ljubljana_alternatives_parking_kino_siska_title',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_ljubljana_alternatives_parking_kino_siska_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/kino-siska-parking.jpg',
      condition: 'car',
      link: 'https://maps.app.goo.gl/1PtJUReZcFPmhZnA8',
    },
    {
      type: 'image',
      content: '/locations/ljubljana/form-kino-siska-parking-to-office.jpg',
      condition: 'car',
    },

    // BUS

    {
      type: 'body-text',
      content: 'location_details_ljubljana_intro_bus',
      condition: 'bus',
    },
    {
      type: 'map',
      condition: 'bus',
      zoom: 16,
      center: { lat: 46.06809029173705, lng: 14.490389151227626 },
      markerPositions: [{ lat: 46.066859341449714, lng: 14.48984228127852 }],
      busStops: [
        { lat: 46.066642356174576, lng: 14.489729089468733 },
        { lat: 46.069667676118804, lng: 14.489616037085472 },
      ],
    },
    {
      condition: 'bus',
      type: 'bus-stops',
      title: 'location_details_ljubljana_bus_stops_najami',
      image: '/locations/ljubljana/bus-stop-na-jami.jpg',
      options: [
        {
          value: 'stop-1',
          content: '7',
          color: '#24A8C3',
        },
      ],
    },
    {
      condition: 'bus',
      type: 'bus-stops',
      image: '/locations/ljubljana/bus-stop-kino-siska.jpg',
      title: 'location_details_ljubljana_bus_stops_kino_siska',
      options: [
        {
          value: 'stop-1',
          content: '1',
          color: '#AD2F31',
        },
        {
          value: 'stop-2',
          content: '1B',
          color: '#AD2F31',
        },
        {
          value: 'stop-3',
          content: '3',
          color: '#D74A35',
        },
        {
          value: 'stop-4',
          content: '3B',
          color: '#D74A35',
        },
        {
          value: 'stop-5',
          content: '5',
          color: '#874481',
        },
        {
          value: 'stop-6',
          content: '8',
          color: '#1B558F',
        },
        {
          value: 'stop-7',
          content: '22',
          color: '#E7963A',
        },
        {
          value: 'stop-8',
          content: '25',
          color: '#007FAD',
        },
        {
          value: 'stop-9',
          content: 'N1',
          color: '#0066AF',
        },
        {
          value: 'stop-10',
          content: 'N3',
          color: '#0066AF',
        },
        {
          value: 'stop-11',
          content: 'N6',
          color: '#0066AF',
        },
      ],
    },
  ],
  Vodice: [
    // CAR
    {
      type: 'title',
      content: 'location_details_vodice_title',
    },
    {
      type: 'options-selector',
      options: [
        {
          value: 'car',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none"><path d="M32.4447 6.31295C32.3686 6.09151 32.099 5.91928 31.8739 5.91928C30.8992 5.91928 29.9247 5.91928 28.9499 5.91928C28.7249 5.91928 28.4552 6.09151 28.3791 6.31295C28.3047 6.52969 28.249 6.72308 28.2121 6.90496L26.2589 1.50136C25.9367 0.61031 25.0835 0.0116577 24.1361 0.0116577H9.19757C8.25009 0.0116577 7.39707 0.61031 7.07476 1.50152L5.1215 6.9056C5.08444 6.72357 5.02882 6.52994 4.9543 6.31295C4.87824 6.09151 4.60855 5.91928 4.38354 5.91928C3.4089 5.91928 2.43425 5.91928 1.45953 5.91928C1.23452 5.91928 0.964827 6.09151 0.88877 6.31295C0.592646 7.17513 0.592808 7.6687 0.888851 8.53096C0.964909 8.7524 1.2346 8.92463 1.45961 8.92463C2.43433 8.92463 3.40898 8.92463 4.38362 8.92463C4.38638 8.92463 4.3893 8.9239 4.39214 8.92382L4.34803 9.04601C3.75181 9.2441 3.32133 9.80537 3.32133 10.4682V14.9931V15.366V20.3732C3.32133 20.7713 3.64388 21.0938 4.04193 21.0938H7.66863C8.0666 21.0938 8.38923 20.7713 8.38923 20.3732V16.8653H24.9444V20.3732C24.9444 20.7713 25.267 21.0938 25.665 21.0938H29.2917C29.6898 21.0938 30.0123 20.7713 30.0123 20.3732V15.366V14.9931V10.4682C30.0123 9.80554 29.582 9.24434 28.986 9.04609L28.9418 8.92382C28.9445 8.9239 28.9473 8.92455 28.95 8.92455C29.9247 8.92455 30.8993 8.92455 31.874 8.92455C32.0991 8.92455 32.3687 8.75232 32.4448 8.53088C32.7408 7.6687 32.7407 7.17513 32.4447 6.31295ZM9.47351 2.66347H23.8582L26.1373 8.96882H7.19444L9.47351 2.66347ZM9.87471 13.4107H6.84067C6.18972 13.4107 5.66209 12.8831 5.66209 12.2322C5.66209 11.5813 6.18963 11.0536 6.84067 11.0536H9.87471C10.5256 11.0536 11.0533 11.5812 11.0533 12.2322C11.0534 12.8831 10.5256 13.4107 9.87471 13.4107ZM26.4927 13.4107H23.4587C22.8078 13.4107 22.2801 12.8831 22.2801 12.2322C22.2801 11.5813 22.8078 11.0536 23.4587 11.0536H26.4927C27.1437 11.0536 27.6713 11.5812 27.6713 12.2322C27.6713 12.8831 27.1437 13.4107 26.4927 13.4107Z" fill="#6C6D70"/></svg>',
        },
        {
          value: 'bus',
          content:
            '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M3.3333 15.2194V11.2194C3.7013 11.2194 3.99998 10.9208 3.99998 10.5528C3.99998 10.1848 3.7013 9.88608 3.3333 9.88608C1.49468 9.88608 0 11.3821 0 13.2194V14.5527C0 15.6554 0.897309 16.5527 1.99999 16.5527H3.3333C3.7013 16.5527 3.99998 16.2541 3.99998 15.8861C3.99998 15.5181 3.7013 15.2194 3.3333 15.2194Z" fill="#6C6D70"/><path d="M28.6667 9.88608C28.2987 9.88608 28 10.1848 28 10.5528C28 10.9208 28.2987 11.2194 28.6667 11.2194V15.2194C28.2987 15.2194 28 15.5181 28 15.8861C28 16.2541 28.2987 16.5527 28.6667 16.5527H30C31.1027 16.5527 32 15.6554 32 14.5527V13.2194C32 11.3821 30.5053 9.88608 28.6667 9.88608Z" fill="#6C6D70"/><path d="M11.3333 28.5527C10.9653 28.5527 10.6666 28.8514 10.6666 29.2194H6.66662C6.66662 28.8514 6.36794 28.5527 5.99994 28.5527C5.63194 28.5527 5.33325 28.8514 5.33325 29.2194V30.5527C5.33325 31.6554 6.23056 32.5527 7.33324 32.5527H9.99998C11.1027 32.5527 12 31.6554 12 30.5527V29.2194C12 28.8514 11.7013 28.5527 11.3333 28.5527Z" fill="#6C6D70"/><path d="M26 28.5527C25.632 28.5527 25.3333 28.8514 25.3333 29.2194H21.3333C21.3333 28.8514 21.0346 28.5527 20.6666 28.5527C20.2986 28.5527 20 28.8514 20 29.2194V30.5527C20 31.6554 20.8973 32.5527 22 32.5527H24.6667C25.7694 32.5527 26.6667 31.6554 26.6667 30.5527V29.2194C26.6667 28.8514 26.368 28.5527 26 28.5527Z" fill="#6C6D70"/><path d="M26 0.552734H6.00005C4.16137 0.552734 2.66675 2.04873 2.66675 3.88603V26.5526C2.66675 28.3899 4.16143 29.8859 6.00005 29.8859H26C27.8386 29.8859 29.3333 28.3899 29.3333 26.5526V3.88603C29.3333 2.04873 27.8386 0.552734 26 0.552734ZM8.66672 3.21941H23.3334C24.436 3.21941 25.3333 4.11672 25.3333 5.2194C25.3333 6.32209 24.436 7.21939 23.3334 7.21939H8.66672C7.56404 7.21939 6.66673 6.32209 6.66673 5.2194C6.66673 4.11672 7.56404 3.21941 8.66672 3.21941ZM8.66672 25.8859C7.56404 25.8859 6.66673 24.9886 6.66673 23.886C6.66673 22.7833 7.56404 21.886 8.66672 21.886C9.76941 21.886 10.6667 22.7833 10.6667 23.886C10.6667 24.9886 9.76934 25.8859 8.66672 25.8859ZM23.3333 25.8859C22.2306 25.8859 21.3333 24.9886 21.3333 23.886C21.3333 22.7833 22.2306 21.886 23.3333 21.886C24.436 21.886 25.3333 22.7833 25.3333 23.886C25.3333 24.9886 24.436 25.8859 23.3333 25.8859ZM26.6666 17.2194C26.6666 18.322 25.7693 19.2193 24.6667 19.2193H7.33335C6.23067 19.2193 5.33336 18.322 5.33336 17.2194V10.5527C5.33336 9.45001 6.23067 8.5527 7.33335 8.5527H24.6666C25.7693 8.5527 26.6666 9.45001 26.6666 10.5527V17.2194H26.6666Z" fill="#6C6D70"/></svg>',
        },
      ],
    },
    {
      type: 'body-text',
      content: 'location_details_vodice_intro_car',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_vodice_intro_car_free_parking_title',
      condition: 'car',
    },
    {
      type: 'map',
      condition: 'car',
      center: { lat: 46.1872553837015, lng: 14.490841725899767 },
      markerPositions: [{ lat: 46.1872553837015, lng: 14.490841725899767 }],
      link: 'https://maps.app.goo.gl/YRWjLKXNUXsubr2h7',
    },
    {
      type: 'body-text',
      content: 'location_details_vodice_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/vodice/vodice-parking.jpg',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_vodice_explanation_2',
      condition: 'car',
    },
    {
      type: 'subtitle',
      content: 'location_details_vodice_parking_lot_entrance_title',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/vodice/vodice-parking-entrance-1.jpg',
      title: 'location_details_vodice_parking_lot_entrance_1',
      condition: 'car',
    },
    {
      type: 'image-directions',
      image: '/locations/vodice/vodice-parking-entrance-2.jpg',
      title: 'location_details_vodice_parking_lot_entrance_2',
      condition: 'car',
    },
    {
      type: 'body-text',
      content: 'location_details_vodice_parking_lot_entrance_explanation',
      condition: 'car',
    },
    {
      type: 'image',
      content: '/locations/vodice/vodice-entrance.jpg',
      condition: 'car',
    },

    // BUS

    {
      type: 'body-text',
      content: 'location_details_vodice_intro_bus',
      condition: 'bus',
    },
    {
      type: 'map',
      condition: 'bus',
      center: { lat: 46.18718855181955, lng: 14.491071002774472 },
      markerPositions: [{ lat: 46.18718855181955, lng: 14.491071002774472 }],
      busStops: [{ lat: 46.18685435122987, lng: 14.491441407673582 }],
    },
    {
      type: 'body-text',
      content: 'location_details_vodice_intro_bus_explanation',
      condition: 'bus',
    },
    {
      type: 'image',
      content: '/locations/vodice/vodice-bus-stop.jpg',
      condition: 'bus',
    },
    {
      type: 'image',
      content: '/locations/vodice/vodice-entrance.jpg',
      condition: 'bus',
    },
  ],
};

const locationDetails = ref<LocationDetails[]>([]);

onMounted(() => {
  if (store.locations[locationId.value]) {
    locationDetails.value = locationDetailsAll[locationId.value] || [];

    const optionsSelector = locationDetails.value.find((item) => item.type === 'options-selector');
    if (optionsSelector && optionsSelector.options && optionsSelector.options.length > 0) {
      selectedLocation.value = optionsSelector.options[0].value;
    }
    const allParkings = locationDetails.value.filter((item) => item.type === 'parking' && item.api);
    allParkings.forEach((parking) => {
      if ('api' in parking && parking.api) {
        loadParking(parking.api);
        setInterval(() => {
          loadParking(parking.api);
        }, 60000);
      }
    });
  } else {
    router.push({ name: 'LandingPage' });
  }
});

function toggleAccordion(value: string) {
  if (accrodionOpened.value.includes(value)) {
    accrodionOpened.value = accrodionOpened.value.filter((item) => item !== value);
  } else {
    accrodionOpened.value.push(value);
  }
}

function checkFieldConditions(field: LocationDetails) {
  if (!('condition' in field) || field.condition === undefined || field.condition === null) {
    return true;
  }

  if (selectedLocation.value === field.condition) {
    return true;
  }

  return false;
}

async function fetchParkingData(api: string) {
  try {
    const response = await axios.get(api);
    return response.data;
  } catch (error) {
    console.error('Error fetching parking data:', error);
    return 0;
  }
}

async function loadParking(api: string) {
  parkingData.value[api] = await fetchParkingData(api);
}

//
// {
//   type: 'image',
//   content: '/locations/ljubljana-office.png',
//   link: 'https://example.com/ljubljana-office',
//   info: 'Ljubljana Office',
// },
// {
//   type: 'subtitle',
//   content: 'Subtitle',
// },
// {
//   type: 'body-text',
//   content:
//     'Body - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
// },
// {
//   type: 'directions',
//   options: [
//     {
//       value: 'forward',
//       content: 'Go back to the parking lot entrance ',
//     },
//     {
//       value: 'right',
//       content: 'Turn left',
//     },
//     {
//       value: 'left',
//       content: 'After 50m, turn left and you’ll see our dental office',
//     },
//   ],
//   title: 'From parking lot to the dental office',
//   image: '/locations/ljubljana-directions.png',
// },
// {
//   type: 'accordion',
//   options: [
//     {
//       value: 'item-1',
//       title: 'Accordion item 1',
//       content:
//         'Body - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//     },
//     {
//       value: 'item-2',
//       title: 'Accordion item 2',
//       content:
//         'Body - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//     },
//     {
//       value: 'item-3',
//       title: 'Accordion item 3',
//       content:
//         'Body - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//     },
//   ],
// },
</script>
